<div [id]="idModal" aria-hidden="true" class="c-modal">
  <div tabindex="-1"  class="c-modal_overlay">
    <div role="dialog"
         aria-modal="true"
         class="c-modal_container c-modal_container--info">

      <div class="c-modal_cont">
        <div class="spinner"></div>

        <div class="cont-title-sec text-center">
          <h3 class="color-blue-dark">
            {{ title }}
          </h3>
        </div>

        <div class="d-flex justify-content-center">
          <p class="text-center">
            {{ textDescription }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
